import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';
import { FactorAppliesToLinkValue } from 'constantsProject';
import type { PriceListRatioRowData } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

import {
    uerPriceListRatioForIncludingToContractChangeCodeFilterGql,
    uerPriceListRatioForIncludingToContractChangeNameFilterGql,
    uerPriceListRatioForIncludingToContractChangeStatusFilterGql,
} from './agreementsRatioQueries';

export const useAgreementsUersForRatioColumns = ({
    ratioName,
    agreementId,
    changeFilterHandler,
}: {
    ratioName: string;
    agreementId: number;
    changeFilterHandler: ({ checkedValues, fieldName }: { fieldName: string; checkedValues: string[] }) => void;
}) => {
    const filterVariables = useMemo(
        () => ({
            contractChangeId: agreementId,
            ratioCode: ratioName,
        }),
        [agreementId, ratioName],
    );

    return useMemo<ColDef<PriceListRatioRowData>[]>(
        () => [
            {
                field: 'appliesToCode',
                headerName: 'Шифр',
                width: 200,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables: filterVariables,
                    changeFilterHandler,
                    dataAccessor: 'uerPriceListRatioForIncludingToContractChangeCodeFilter',
                    whereVariables: ['value'],
                    childFieldAccessor: 'value',
                    columns: [
                        {
                            headerName: 'Шифр',
                            field: 'value',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    query: uerPriceListRatioForIncludingToContractChangeCodeFilterGql,
                },
            },
            {
                field: 'appliesToCodeName',
                headerName: 'Наименование',
                minWidth: 250,
                flex: 1,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables: filterVariables,
                    changeFilterHandler,
                    dataAccessor: 'uerPriceListRatioForIncludingToContractChangeNameFilter',
                    whereVariables: ['value'],
                    childFieldAccessor: 'value',
                    columns: [
                        {
                            headerName: 'Наименование',
                            field: 'value',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    query: uerPriceListRatioForIncludingToContractChangeNameFilterGql,
                },
            },
            {
                field: 'appliesToLinkStatus',
                headerName: 'Статус связи',
                valueFormatter: (params) => {
                    const { data } = params;

                    return data ? FactorAppliesToLinkValue[data.appliesToLinkStatus] : '';
                },
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables: filterVariables,
                    changeFilterHandler,
                    dataAccessor: 'uerPriceListRatioForIncludingToContractChangeStatusFilter',
                    whereVariables: ['value'],
                    childFieldAccessor: 'value',
                    columns: [
                        {
                            headerName: 'Статус связи',
                            field: 'value',
                            checkboxSelection: true,
                            valueFormatter: ({ data }: { data: { value: string | undefined } }) =>
                                data?.value ? FactorAppliesToLinkValue[data.value] : '',
                            width: 400,
                        },
                    ],
                    query: uerPriceListRatioForIncludingToContractChangeStatusFilterGql,
                },
                width: 150,
            },
        ],
        [changeFilterHandler, filterVariables],
    );
};
